// This file is auto-generated by @hey-api/openapi-ts
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getAuthToken = (auth, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const token = typeof callback === "function" ? yield callback(auth) : callback;
    if (!token) {
        return;
    }
    if (auth.scheme === "bearer") {
        return `Bearer ${token}`;
    }
    if (auth.scheme === "basic") {
        return `Basic ${btoa(token)}`;
    }
    return token;
});
//# sourceMappingURL=auth.gen.js.map